import React, { useState } from 'react';
import { Search, ReceiptText } from 'lucide-react';
import CustomerLayout from '../../components/CustomerLayout';
import { Input } from '../../components/ui/input';
import { useApi } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import { CurrencySwitcher } from '../../components/CurrencySwitcher';
import { useCustomerCurrency } from '../../hooks/useCustomerCurrency';
import { CustomerPageHeading } from '../../components/customer/CustomerPageHeading';
import { CustomerActivity } from '../../components/customer/CustomerActivity';

export default function HistoryPage() {
  const { user } = useAuth();
  const [q, setQ] = useState('');
  const [currency, setCurrency] = useCustomerCurrency();
  const { data: all, loading, error } = useApi('/portal/transactions');
  const list = (all || []).filter(tx => tx.currency === currency && (!q || tx.refNo.toLowerCase().includes(q.toLowerCase()) || (tx.remarks || '').toLowerCase().includes(q.toLowerCase())));
  return <CustomerLayout><section data-testid="customer-history-page">
    <CustomerPageHeading title="Transactions" description={user?.accountNo} icon={ReceiptText} testId="history-heading" />
    <div className="customer-filter-bar"><div className="customer-search"><Search size={18} /><Input data-testid="history-search" aria-label="Search reference or note" value={q} onChange={event => setQ(event.target.value)} placeholder="Search reference or note" /></div><CurrencySwitcher currency={currency} onChange={setCurrency} /></div>
    <CustomerActivity transactions={list} prefix="history" loading={loading} error={error} />
  </section></CustomerLayout>;
}